const messages = {
    'masterdata.add.success': 'Master data added successfully!',
    'masterdata.edit.success': 'Master data edited successfully!',
    'masterdata.delete.success': 'Master data deleted successfully!',    
    'emailtemplate.add.success': 'Email template edded successfully!',
    'emailtemplate.edit.success': 'Email template edited successfully!',
    'emailtemplate.delete.success': 'Email template deleted successfully!',    
    'system.leavewithoutsaving.title': 'System Notice',
    'system.leavewithoutsaving.content': 'If you leave the current page, unsaved data will be lost. Are you sure you want to leave?',    
    'carriers.add.success': 'Carriers added successfully!',
    'carriers.edit.success': 'Carriers edited successfully!',
    'carriers.delete.success': 'Carriers deleted successfully!', 
    'carriersaccount.authorize.success': 'Authorization email sent successfully!',
    'freightbillaccount.add.success': 'Freight bill account added successfully!',
    'freightbillaccount.edit.success': 'Freight bill account edited successfully!',
    'freightbillaccount.delete.success': 'Freight bill account deleted successfully!', 
    'accounts.add.success': 'Accounts added successfully!',
    'accounts.edit.success': 'Accounts edited successfully!',
    'accounts.delete.success': 'Accounts deleted successfully!', 
    'freight.updatestauts.success':'Update status successfully!',
    'waybill.updatestatus.success':'Update print status successfully!',
    'freight.upload.success':'Upload successfully!',
    'freight.sendtodppo.success':'Send to DPPO successfully!',
    'freight.getdhlbilling.success':"Get DHL Billing successfully!",
    'freight.getdhlbilling.fail':"Get DHL Billing failed!",
    'freight.export.fail':'Export failed!',
    'freight.senddppo.fail': "Send to PO failed!",
    'waybill.getprintwaybilldocument.success':'Get Print WaybillDocument successfully!',    
    'company.add.success': 'Company added successfully!',
    'company.edit.success': 'Company edited successfully!',
    'company.delete.success': 'Company deleted successfully!',
    'company.contacts.tips': 'Use between multiple values; Separate',
    'department.add.success': 'Company added successfully!',
    'department.edit.success': 'Company edited successfully!',
    'department.delete.success': 'Company deleted successfully!',
    'carrieraccount.password.tips': 'If you need to change your password, please enter',
    'carrieraccount.appsecret.tips': 'If you need to change your app secret, please enter',
    'carrieraccount.aessecret.tips': 'If you need to change your AES secret, please enter',
    'region.add.success': 'Region added successfully!',
    'region.edit.success': 'Region edited successfully!',
    'region.delete.success': 'Region deleted successfully!',
    'addressbook.save.success': 'Address saved successfully!',
    'addressbook.add.success': 'Address book added successfully!',
    'addressbook.edit.success': 'Address book edited successfully!',
    'addressbook.delete.success': 'Address book deleted successfully!',
    'address.required.tip': 'Please provide complete address information!',
    'address.selectone.tip': 'Please select an address!',
    'country.save.success': 'Country/Region saved successfully!',
    'country.add.success': 'Country/Region added successfully!',
    'country.edit.success': 'Country/Region edited successfully!',
    'country.delete.success': 'Country/Region deleted successfully!',
    'hscode.add.success': 'HS code added successfully!',
    'hscode.edit.success': 'HS code edited successfully!',
    'hscode.delete.success': 'HS code deleted successfully!',
    'legalunit.add.success': 'Legal unit added successfully!',
    'legalunit.edit.success': 'Legal unit edited successfully!',
    'legalunit.delete.success': 'Legal unit deleted successfully!',
    'sparrowtemplate.add.success': 'Sparrow template added successfully!',
    'sparrowtemplate.edit.success': 'Sparrow template edited successfully!',
    'sparrowtemplate.delete.success': 'Sparrow template deleted successfully!',
    'expressorder.save.success': 'Express order saved successfully!',
    'expressorder.edit.success': 'Express order edited successfully!',
    'expressorder.delete.success': 'Express order deleted successfully!',
    'expressorder.submit.success': 'Express order submited successfully!',
    'expressorder.process.success': 'Express order processed successfully!',
    'expressorder.cancel.success': 'Express order canceled successfully!',
    'expressorder.signback.tip': 'If Choose Yes, Paper POD(Proof of Delivery)is required and corresponding freight will incur. ',
    'expressorder.address.citytip': 'City format：厦门市',
    'mobile.expressorder.cargo.notice': 'Note: The actual weight and volume are determined by the delivery personnel. The weight of the item may increase after packaging, and fees will be charged based on the volume and weight when the weight is small and the volume is large',
    'freight.confirmbilling.success': 'Bill confirmation successful!',
    'freight.approvebilling.success': 'Bill approval successful!',
    'purchaserequest.save.success': 'Purchase Request saved successfully!',
    'purchaserequest.submit.success': 'Purchase Request submited successfully!',
    'purchaserequest.process.success': 'Purchase Request processed successfully!',
    'purchaserequest.cancel.success': 'Purchase Request cancelled successfully!',
    'purchaserequest.netamount.cannotempty': 'Please maintain the value of Net Price!',
    'expressorder.plannedshippingdatetime.tip': 'Pickup Time-Ship Time ≥120 Minutes',
    'expressorder.plannedshippingdatetimeandpickuptime.tip': 'Door to door pickup can only be scheduled before 5 oclock. If there is an urgent package, please contact the courier (door-to-door pickup is not available on weekends and holidays)',
    'expressorder.enablePickupAddress.tip': 'Pickup address is only supported for DHL. Unless the pickup address needs to be different from the order address, it does not need to be filled in.',
    'expressorder.isNeutraldelivery.tip': 'Only DHL Support',
    'expressorder.cargoType.tip': 'The description of the package must be in English',
    'expressorder.cargo.cannotempty': 'The package information cannot be empty, please check!',
    'expressorder.exportdeclaration.cannotempty': 'The line items on invoice cannot be empty, please check!',
    'expressorder.datePickCheck.pickTimesmall': 'The pick-up DateTime must be 2 hours later than the planned Shipping DateTime',
    'freightbill.records.cannotempty': 'Please select the billing record that needs to be operated on!',
    'delegation.disable.success': 'Delegation disabled successfully!',
    'delegation.enable.success': 'Delegation enabled successfully!'
  };
  export default messages;
  